import { render, staticRenderFns } from "./Extras.vue?vue&type=template&id=13804e80&"
import script from "./Extras.vue?vue&type=script&lang=js&"
export * from "./Extras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports